import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class PictureComponent extends Component {
  init() {
    this.img = this.element.querySelector('img')
    this.sources = [...this.element.querySelectorAll('source')]

    if (!this.img || !this.sources.length) {
      return
    }

    this.sources.forEach(source => window.matchMedia(source.media ?? 'screen').addListener(result => result.matches && this.applySource(source)))
    this.applySource(this.sources.find(source => window.matchMedia(source.media).matches))
  }

  applySource(source) {
    if (!this.img || !source) {
      return
    }

    this.img.style.objectFit = source.style?.objectFit ?? this.img.style.objectFit
    this.img.style.objectPosition = source.style?.objectPosition ?? this.img.style.objectPosition
    this.img.srcset = source.src
  }
}

window.addEventListener('init-load', () => loadComponent(document.documentElement, 'picture', PictureComponent))
